{
  "actions.activate": "Activer",
  "actions.add_deadline": "Ajouter une échéance",
  "actions.addresses": "Adresses",
  "actions.ai_translation": "AI Translation",
  "actions.apply": "Appliquer",
  "actions.cancel": "Annuler",
  "actions.continue": "Poursuivre",
  "actions.copy_email": "Copie de l'e-mail",
  "actions.copy_link": "Copie le lien",
  "actions.create": "Créer",
  "actions.create_box": "Créez Box",
  "actions.deactivate": "Désactiver",
  "actions.delete": "Supprimer",
  "actions.disabled": "désactivé",
  "actions.download": "Télécharger",
  "actions.duplicate": "Dupliquer",
  "actions.edit": "Editer",
  "actions.edit_deadline": "Éditer l'échéance",
  "actions.folder": "Nouveau dossier",
  "actions.install_app": "Installer l'application DeepBox",
  "actions.language": "Langue",
  "actions.load_more": "Charger plus...",
  "actions.login": "Connexion",
  "actions.logout": "Déconnexion",
  "actions.manage": "Gérer",
  "actions.manage_your_account": "Gérer votre compte",
  "actions.more": "Plus...",
  "actions.more_boxes": "Plus de box...",
  "actions.move": "Déplacer",
  "actions.move_to": "Déplacer vers {nodeName}",
  "actions.new": "Nouveau",
  "actions.new_entry": "Nouvelle inscription",
  "actions.no": "Non",
  "actions.ok": "Ok",
  "actions.open_details": "Afficher les détails",
  "actions.open_service": "Ouvrir {service}",
  "actions.preview": "Aperçu",
  "actions.refresh": "Actualiser",
  "actions.remove": "Supprimer",
  "actions.rename": "Renommer",
  "actions.reset": "Réinitialiser",
  "actions.reset_search": "Réinitialiser la recherche",
  "actions.select": "Sélectionner",
  "actions.try_again": "Essayer à nouveau",
  "actions.upload": "Déposer",
  "actions.upload_file": "Déposer fichiers",
  "actions.upload_folder": "Déposer dossier",
  "actions.view": "Vue",
  "actions.yes": "Oui",
  "admin.navigation.account": "COMPTE",
  "admin.navigation.account_profile": "Votre profil",
  "admin.navigation.organization": "Information Sur L'organisation",
  "admin.navigation.organization_boxes": "Boxes",
  "admin.navigation.organization_boxes_tags": "Tags",
  "admin.navigation.organization_groups": "Groupes",
  "admin.navigation.organization_personal": "Info personnelles",
  "admin.navigation.organization_subheader": "ORGANISATION",
  "admin.navigation.organization_subscription": "Abonnement",
  "admin.navigation.organization_users": "Utilisateurs",
  "admin.navigation.organization_verification_in_progress": "Vérification",
  "alerts.aba_ninja.continue_process": "Cette box est liée à DeepNinja.",
  "alerts.box.only_advanced_box_selectable": "Une seule box de type \"Advanced\" peut être sélectionnée.",
  "alerts.company_accounting.open_invoices.action": "Vers les factures",
  "alerts.company_accounting.open_invoices.label": "Paiement en attente",
  "alerts.company_accounting.open_invoices.member.content": "Votre organisation présente au moins une facture impayée. Veuillez en informer l'Owner de l'organisation, car des factures impayées peuvent entraîner la désactivation de l'organisation.",
  "alerts.company_accounting.open_invoices.owner.content": "Vous avez au moins une facture impayée. Veuillez la régler afin d'éviter la désactivation de votre organisation.",
  "alerts.company_accounting.overusing.action": "Veuillez vérifier votre abonnement.",
  "alerts.company_accounting.overusing.label": "Surcapacité",
  "alerts.company_accounting.overusing.member.content": "L'organisation utilise actuellement plus de capacité que ce qui est disponible dans le cadre de l'abonnement. Un dépassement de capacité peut entraîner la désactivation de l'organisation. Veuillez en informer le Owner de l'organisation.",
  "alerts.company_accounting.overusing.owner.content": "Votre organisation utilise actuellement plus de capacité que ce qui est inclus dans votre abonnement. Veuillez mettre à niveau votre abonnement ou réduire l'utilisation afin d'éviter la désactivation de l'organisation.",
  "alerts.company_verification.action": "Poursuivre",
  "alerts.company_verification.content": "Le processus de vérification est en cours. Vous pourrez créer la première box dès que la vérification sera terminée.",
  "alerts.company_verification.title": "Vérification",
  "alerts.hoop.continue_process": "Cette Box est liée à Hoop. Chez Hoop, vous pouvez à tout moment vérifier l'état d'avancement de la création/mutation de l'entreprise.",
  "alerts.portal.continue_process": "Cette box est liée à DeepPortal.",
  "api.deepbox.errors.node.move.out-of-box.prohibited.generic-folder": "Impossible de déplacer un dossier générique vers une autre box. | {n} dossiers génériques ne peuvent pas être déplacés vers une autre box.",
  "api.deepbox.errors.node.move.out-of-box.prohibited.shared-folder": "Impossible de déplacer un dossier partagé vers une autre box.. | {n} dossiers partagés ne peuvent pas être déplacés vers une autre box.",
  "api.deepbox.errors.node.move.recursive": "Un dossier parent ne peut pas être déplacé vers un dossier enfant. | {n} dossiers parents ne peuvent pas être déplacés vers un dossier enfant.",
  "apps.subtitle.deepbox": "Stockage et partage sécurisés de documents",
  "apps.subtitle.deepsign": "Signatures électroniques conformes à la législation",
  "base.date_picker.example_date": "ex.: {exemple}",
  "base.date_picker.modal_btn_cancel": "Annuler",
  "base.date_picker.modal_btn_save": "Reprendre",
  "box.boxes_switch": "Boxes",
  "box.n_selected_detail": "1 sélectionné ({detail}) | {n} sélectionné ({detail})",
  "box.policies.can_not_access_inbox_and_files.text": "Vous n'êtes pas autorisé à déplacer les fichiers vers l'emplacement sélectionné.",
  "box.private.generics.deepmail.error.logged_in_wrong_account.message": "Vous êtes actuellement connecté avec l'utilisateur <b>{userEmail}</b>. <br />Le message crypté a été envoyé à l'adresse e-mail <b>{queryEmail}</b>. Vous devrez vous connecter avec cette adresse e-mail.",
  "box.private.generics.deepmail.error.logged_in_wrong_account.title": "Vous êtes connecté avec le mauvais compte",
  "box.private.generics.deepmail.title": "DeepMail",
  "box.private.generics.deepsign.banner.content": "Nella cartella DeepSign troverete tutti i documenti completati. Per i processi di firma in sospeso o nuovi, passate alla {link}",
  "box.private.generics.deepsign.banner.link": "DeepSign App",
  "box.private.generics.deepsign.title": "DeepSign Storage",
  "box.types.advanced": "Advanced Box",
  "box.types.advanced_per_use": "Advanced Box avec prix fixe",
  "box.types.portal": "Portal",
  "box.types.simple": "Simple Box",
  "box_details.access.error.forbidden": "Le dossier n'existe pas ou vous n'avez pas la permission d'accéder à ce dossier.",
  "box_details.archive.banner.subtitle": "Intégrité vérifiable",
  "box_details.archive.banner.text": "Inaltérable · Conservation de 10 ans à compter de la réception · Horodatage qualifié selon ZertES",
  "box_details.all_files_reviewed": "Tous les fichiers ont été contrôlés.",
  "box_details.details_drawer.category": "Catégorie",
  "box_details.details_drawer.comments": "Commentaires",
  "box_details.details_drawer.created": "Créé",
  "box_details.details_drawer.details": "Détails",
  "box_details.details_drawer.details_file": "Détails du fichier",
  "box_details.details_drawer.details_folder": "Détails du dossier",
  "box_details.details_drawer.file": "Fichier",
  "box_details.details_drawer.files": "Documents",
  "box_details.details_drawer.folder": "Dossier",
  "box_details.details_drawer.location": "lieu",
  "box_details.details_drawer.me": "Moi",
  "box_details.details_drawer.modified": "Modifié",
  "box_details.details_drawer.opened": "Ouvert",
  "box_details.details_drawer.owner": "Propriétaire",
  "box_details.details_drawer.queue": "Inbox",
  "box_details.details_drawer.sections.comments.counter": "Commentaire | Commentaires",
  "box_details.details_drawer.sections.comments.text_add": "Ajouter un commentaire",
  "box_details.details_drawer.sections.deep_validator.actions.processing": "Traitement en cours...",
  "box_details.details_drawer.sections.deep_validator.actions.re_validate": "Re-valider",
  "box_details.details_drawer.sections.deep_validator.actions.validate": "Valider",
  "box_details.details_drawer.sections.deep_validator.jurisdiction": "Juridiction",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.Unknown": "Domaine juridique inconnu",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.ZertES": "ZertES",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.eIDAS": "eIDAS",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.indeterminate": "1 signature indéterminée | {n} signatures indéterminées",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.invalid": "1 signature invalide | {n} signatures invalides",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.unsupported": "1 signature non prise en charge | {n} signatures non prises en charge",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.valid": "1 signature valide | {n} signatures valides",
  "box_details.details_drawer.sections.deep_validator.no_signatures_found": "Aucune signature trouvée",
  "box_details.details_drawer.sections.deep_validator.nr_of_signatures": "Nombre de signatures",
  "box_details.details_drawer.sections.deep_validator.signature_type": "Type de signature",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESeal": "Sceau électronique qualifié",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESig": "Signature électronique qualifiée",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESeal": "Sceau électronique réglementé",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESig": "Signature électronique réglementé",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESeal": "Sceau électronique qualifié (indéterminé)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESig": "Signature électronique qualifiée (indéterminé)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_Unknown": "Signature électronique indéterminé",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES": "Signature électronique invalide",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC": "Signature électronique qualifiée indéterminée (invalide)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC_with_QSCD": "Signature électronique qualifiée indéterminée (invalide)",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESeal": "Sceau électronique qualifié",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESig": "Signature électronique qualifiée",
  "box_details.details_drawer.sections.deep_validator.signature_types.Unknown": "Type de signature inconnu",
  "box_details.details_drawer.sections.deep_validator.time_of_signature": "Date de la signature",
  "box_details.details_drawer.sections.deep_validator.validation_result_indication": "Résultat vérification de la signature",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.FAILED": "La signature est invalide.",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.INDETERMINATE": "La signature est indéterminée",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.NO_SIGNATURE_FOUND": "Aucune signature trouvée",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.PASSED": "La signature est valide.",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_FAILED": "La signature est invalide.",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_PASSED": "La signature est valide.",
  "box_details.details_drawer.sections.deep_validator.validation_results": "Résultat de l'examen",
  "box_details.details_drawer.sections.tags.assign": "Assigner tags",
  "box_details.details_drawer.sections.tags.counter": "Tag | Tags",
  "box_details.details_drawer.tags": "Tags",
  "box_details.details_drawer.trash": "Corbeille",
  "box_details.folder_is_empty": "Ce dossier est vide.",
  "box_details.items": "1 Elément | {n} Eléments",
  "box_details.load_more": "Charger plus",
  "box_details.more": "Plus",
  "box_details.more_items": "+1 élément | +{n} éléments",
  "box_details.navigation.deadlines": "Délais",
  "box_details.navigation.files": "Documents",
  "box_details.navigation.hint": "Double-cliquez pour naviguer",
  "box_details.navigation.inbox": "Inbox",
  "box_details.navigation.info_no_sub_folder": "Ce dossier ne contient pas de sous-dossier",
  "box_details.navigation.queue": "Inbox",
  "box_details.navigation.trash": "Corbeille",
  "box_details.no_items": "Aucun objet",
  "box_details.trash.empty": "La poubelle est vide",
  "box_details.trash.info.empty": "Les éléments contenus dans la corbeille seront définitivement supprimés au bout de 30 jours. {link}",
  "box_details.trash.info.with_files": "Les éléments contenus dans la corbeille seront définitivement supprimés au bout de 30 jours.",
  "buttons.back": "Retour",
  "buttons.cancel": "Annuler",
  "buttons.confirm": "Confirmer",
  "buttons.continue": "Continuer",
  "buttons.discard": "Supprimer",
  "buttons.done": "Terminé",
  "buttons.ignore_dev_int_only": "Ignorer [DEV/INT uniquement]",
  "buttons.login": "S’identifier",
  "buttons.login_now": "Se connecter maintenant",
  "buttons.proceed": "Procéder",
  "buttons.save": "Sauvegarder",
  "buttons.save_and_continue": "Sauvegarder et continuer",
  "buttons.save_and_verify": "Enregistrer et vérifier",
  "buttons.send": "Envoyer",
  "buttons.start_now": "Commencez maintenant",
  "buttons.to_deepbox": "Aller à DeepBox",
  "buttons.upload": "Déposer",
  "choose_your_box": "Choisissez votre box",
  "confirmation.delete_multiple_nodes_description": "Êtes-vous sûr de vouloir supprimer cet élément ? | Êtes-vous sûr de vouloir supprimer {n} éléments ?",
  "confirmation.delete_multiple_nodes_title": "Supprimer",
  "confirmation.delete_permanently_description": "Êtes-vous sûr de vouloir supprimer {name} définitivement ? | Êtes-vous sûr de vouloir supprimer définitivement {count} éléments ?",
  "confirmation.delete_permanently_title": "Supprimer définitivement",
  "confirmation.empty_trash_description": "Êtes-vous sûr de vouloir supprimer tous les éléments de la corbeille ?",
  "confirmation.empty_trash_title": "Vider la corbeille",
  "confirmation.save_open_changes.msg": "Vous avez apporté des modifications. Voulez-vous les annuler ou les enregistrer?",
  "confirmation.save_open_changes.title": "Révision des modifications",
  "dashboard.private.generics.deepmail.banner.subtitle": "Votre boîte de réception privée pour recevoir des fichiers sensibles en toute sécurité.",
  "dashboard.private.generics.deepmail.banner.title": "DeepMail",
  "dashboard.private.generics.deepsign.banner.subtitle": "Dossier pour les documents DeepSign terminés",
  "dashboard.private.generics.deepsign.banner.title": "DeepSign Storage",
  "dashboard.service.card.deepbox.btn": "Compléter le compte DeepCloud",
  "dashboard.service.card.deepbox.btn_manage": "Gérer",
  "dashboard.service.card.deepbox.content": "Pour pouvoir utiliser DeepBox vous-même, vous devez compléter votre compte. {link}",
  "dashboard.service.card.deepbox.create_box.btn": "Créez Box",
  "dashboard.service.card.deepbox.create_box.content": "Créez gratuitement votre première box pour utiliser la plateforme suisse tout-en-un d'échange sécurisé de documents.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes": "Aucune box n'a pu être trouvée.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes_can_not_onboard": "Vous n'avez pas les droits nécessaires pour créer une boîte. <br />\nContactez un propriétaire ou un administrateur de votre organisation.",
  "dashboard.service.card.deepbox.onboarding_in_progress.btn": "Poursuivre l'onboarding",
  "dashboard.service.card.deepbox.onboarding_in_progress.content": "Pour pouvoir utiliser DeepBox vous-même, vous devez terminer l'onboarding. {link}",
  "dashboard.service.card.deepsign.content": "Signer électroniquement des documents en toute sécurité.",
  "dashboard.service.card.deepsign.no_pending_signs": "Il n'y a actuellement aucun document à signer pour vous.",
  "dashboard.service.card.deepsign.onboarding_in_progress.btn": "Poursuivre l'onboarding DeepSign",
  "dashboard.service.card.deepsign.onboarding_in_progress.content": "Terminez l'onboarding de DeepSign pour pouvoir utiliser DeepSign en tant qu'initiateur. {link}",
  "dashboard.service.card.deepv.btn": "Gérer DeepV",
  "dashboard.service.card.deepv.content": "Ce compte a été explicitement ouvert pour DeepV. Vous pouvez également utiliser DeepBox ou DeepSign avec ce compte si vous le souhaitez. {link}",
  "dashboard.service.card.deepv.onboarding_in_progress.btn": "Continuer l'onboarding de DeepV",
  "dashboard.service.card.deepv.onboarding_in_progress.content": " Terminez l'onboarding de DeepV pour pouvoir utiliser DeepV. {link}",
  "date.added": "Ajouté",
  "date.am": "AM",
  "date.days": "Il y a jour | Il y a {num} jours",
  "date.deleted.days": "il y a jour | il y a jours",
  "date.deleted.hours": "il y a heure | il y a heures",
  "date.deleted.minutes": "il y a minute | il y a minutes",
  "date.deleted.months": "il y a mois | il y a mois",
  "date.deleted.now": "maintenant",
  "date.deleted.years": "il y a année | il y a années",
  "date.expired": "expiré",
  "date.hours": "Il y a heure | Il y a {num} heures",
  "date.in_three_days": "dans 3 jours",
  "date.in_two_days": "dans 2 jours",
  "date.minutes": "Il y a minute | Il y a {num} minutes",
  "date.months": "Il y a mois | Il y a {num} mois",
  "date.now": "Maintenant",
  "date.on": "le",
  "date.opened": "Ouvert",
  "date.pm": "PM",
  "date.today": "Aujourd'hui",
  "date.tomorrow": "Demain",
  "date.years": "Il y a année | Il y a {num} années",
  "date.yesterday": "Hier",
  "deep_ui_lib.core.footer.link.help": "Aider",
  "deep_ui_lib.core.footer.link.impressum": "Mentions légales",
  "deep_ui_lib.core.footer.link.privacy_policy": "Protection des données",
  "deep_ui_lib.core.footer.link.terms_of_service": "Conditions d'utilisation",
  "deep_ui_lib.deep_filter_menu.all": "Tous",
  "deep_ui_lib.deep_filter_menu.clear_selected": "Effacer la sélection",
  "deep_ui_lib.deep_filter_menu.no_matching_options": "Aucune option correspondante",
  "deep_ui_lib.deep_filter_menu.use_value": "Utiliser « {value} »",
  "deepa_chat.context_dialog_title": "Contexte du chat ({n} dossier) | Contexte du chat ({n} dossiers)",
  "deepa_chat.context_filter": "Filtrer les dossiers",
  "deepa_chat.context_label": "Contexte :",
  "deepa_chat.context_others": "+ {n} autre | + {n} autres",
  "deepa_chat.empty_state": "Posez vos questions à DeepA sur les dossiers du contexte de ce chat.",
  "deepa_chat.export.answer": "Réponse",
  "deepa_chat.export.context": "Contexte",
  "deepa_chat.export.file_name": "Nom du fichier",
  "deepa_chat.export.file_name_prefix": "Chat DeepA",
  "deepa_chat.export.format": "Format",
  "deepa_chat.export.formats.docx": "Word (.docx)",
  "deepa_chat.export.formats.html": "HTML (.html)",
  "deepa_chat.export.formats.json": "JSON (.json)",
  "deepa_chat.export.formats.markdown": "Markdown (.md)",
  "deepa_chat.export.formats.pdf": "PDF (.pdf)",
  "deepa_chat.export.formats.txt": "Texte (.txt)",
  "deepa_chat.export.generated_by": "Généré par DeepA",
  "deepa_chat.export.incomplete_answer": "Cette réponse est incomplète.",
  "deepa_chat.export.leftover_file": "Le fichier Word temporaire « {name} » n'a pas pu être supprimé.",
  "deepa_chat.export.location": "Enregistrer dans",
  "deepa_chat.export.no_write_permission": "Vous ne pouvez pas enregistrer de fichiers dans ce dossier.",
  "deepa_chat.export.question": "Question",
  "deepa_chat.export.success": "Chat exporté sous « {name} »",
  "deepa_chat.export.title": "Exporter le chat",
  "deepa_chat.new_chat": "Nouveau chat",
  "deepa_chat.new_chat_hint": "Nouveau chat sur les dossiers sélectionnés, ou sur le dossier actuel si aucun dossier n'est sélectionné",
  "deepa_chat.prompt_placeholder": "Demander à DeepA…",
  "deepa_chat.reply_stopped": "Réponse interrompue",
  "deepa_chat.start_chat_for": "Démarrer un chat pour « {name} »",
  "deepa_chat.stop": "Arrêter",
  "deepa_chat.title": "DeepA Chat",
  "deepmail.error.logged_in_wrong_account.message": "Vous êtes actuellement connecté à l'utilisateur <b>{userEmail}</b>.<br />\nLe DeepMail a été envoyé à l'adresse e-mail <b>{queryEmail}</b>.<br />\nVeuillez vous connecter avec le bon utilisateur.",
  "deepmail.error.logged_in_wrong_account.title": "Connexion avec un faux utilisateur",
  "deeppay.payment_order.execution_date": "Date d'exécution",
  "deeppay.payment_order.info_line": "Ligne d'info",
  "deeppay.payment_order.move_file_message": "Voulez-vous déplacer le fichier dans le dossier \"{folderName}\"?",
  "deeppay.payment_order.order_details": "Détails de la commande",
  "deeppay.payment_order.pay_now": "Payer maintenant",
  "deeppay.payment_order.payment": "Paiement",
  "deeppay.payment_order.payment_amount": "Montant du paiement",
  "deeppay.payment_order.payment_reference": "Référence du paiement",
  "deeppay.payment_order.recipient": "Bénéficiaire",
  "deeppay.payment_order.xml_download": "Télécharger XML",
  "deeppay.payment_order.yes_move": "Oui, déplacer",
  "deeppay.payments_history.by_address_dialog.amount": "Montant",
  "deeppay.payments_history.by_address_dialog.created_at": "Transmis le",
  "deeppay.payments_history.by_address_dialog.created_by": "Transmis par",
  "deeppay.payments_history.by_address_dialog.destination_iban": "Bénéficiaire IBAN",
  "deeppay.payments_history.by_address_dialog.payment_to": "Paiements aux \"{destination}\"",
  "deeppay.payments_history.by_address_dialog.status": "Statut",
  "deeppay.payments_history.card_expandable.title": "Historique des paiements",
  "deeppay.payments_history.list.created_by": "Transmis par",
  "deeppay.payments_history.list.destination": "Destination",
  "deeppay.payments_history.list.status.declined": "Refusé",
  "deeppay.payments_history.list.status.paid": "Payé",
  "deeppay.payments_history.list.status.transmitted": "Transmis",
  "dialogs.add": "Ajouter",
  "dialogs.add_deadline_title": "Ajouter une échéance",
  "dialogs.box": "Box",
  "dialogs.cancel": "Annuler",
  "dialogs.change": "Changer",
  "dialogs.close": "Fermer",
  "dialogs.create": "Créer",
  "dialogs.create_new_deepbox.msg": "Souhaitez-vous créer une box de gratuite ?",
  "dialogs.create_new_deepbox.title": "Créer une box",
  "dialogs.details": "Détails",
  "dialogs.discard.btn": "Supprimer",
  "dialogs.discard.msg": "Êtes-vous sûr de vouloir supprimer tous les changements ?",
  "dialogs.discard.title": "Supprimer les modifications",
  "dialogs.download_app_title": "Télécharger l'application",
  "dialogs.manage_tags": "Gérer les tags",
  "dialogs.member": "Membre",
  "dialogs.members": "Membres : tous les membres de ",
  "dialogs.move_items_title": "Déplacer 1 élément vers... | Déplacer {n} éléments vers...",
  "dialogs.move_to_inbox": "Déplacer vers Inbox",
  "dialogs.name": "Nom",
  "dialogs.newBox": "Nouvelle box",
  "dialogs.no": "Non",
  "dialogs.node_create_new.error.create": "{fileName} n'a pas pu être créé",
  "dialogs.node_create_new.success.create": "{fileName} créé avec succès",
  "dialogs.node_create_new.title": "Créer un nouveau {file} fichier",
  "dialogs.remove_deadline": "Supprimer l'échéance",
  "dialogs.rename": "Renommer",
  "dialogs.save": "Sauvegarder",
  "dialogs.select_location": "Sélectionnez l'emplacement",
  "dialogs.session_invalid.btn_login": "Se connecter",
  "dialogs.session_invalid.loggedout.msg": "Vous avez été déconnecté de DeepBox. Veuillez vous reconnecter.",
  "dialogs.session_invalid.loggedout.title": "Vous avez été déconnecté de DeepBox",
  "dialogs.session_invalid.session_expired.msg": "Pour des raisons de sécurité, vous avez été déconnecté de DeepBox. Veuillez vous reconnecter.",
  "dialogs.session_invalid.session_expired.title": "Vous avez été déconnecté de DeepBox",
  "dialogs.tags.most_used_tags": "Proposition",
  "dialogs.tags.n_selected": "1 sélectionné | {n} sélectionné",
  "dialogs.tags.title": "Tags",
  "dialogs.tags.toast.success.n_updated": "1 fichier a été mis à jour avec succès | {n} fichiers ont été mis à jour avec succès",
  "dialogs.yes": "Oui",
  "drag_drop.msg.error.missing_permissions_to_add_children": "absence d'autorisation pour cette action",
  "drag_drop.msg.error.missing_permissions_to_delete_some_nodes": "2 elements1 élément ne peut être supprimé car vous n'en avez pas l'autorisation. Cet élément sera filtré. | {n} éléments ne peut pas être supprimé parce que vous n'en avez pas l'autorisation. Cet élément sera filtré.",
  "drag_drop.msg.error.move_to_same_parent": "Le fichier ne peut pas être déplacé car le dossier source a été sélectionné. | Les fichiers ne peuvent pas être déplacés car le dossier source a été sélectionné.",
  "drag_drop.msg.error.target_is_one_of_the_nodes_to_be_moved": "Le dossier ne peut pas être déplacé vers lui-même",
  "drag_drop.msg.success.node_moved_to_target": "L'élément a été déplacé avec succès vers le dossier suivant : \"{targetName}\" | Les éléments ont été déplacés avec succès vers le dossier suivant : \"{targetName}\"",
  "error.403.box_elevated_auth_required.btn_2fa": "Activer la 2FA",
  "error.403.box_elevated_auth_required.description": "L'accès nécessite une authentification à deux facteurs (2FA). Activez la 2FA pour accéder au contenu partagé.",
  "error.403.box_elevated_auth_required.link_2fa_info": "Plus d'informations sur la 2FA",
  "error.403.box_elevated_auth_required.title": "Accès refusé",
  "error.403.box_not_found_or_no_access": "La Box n'existe pas ou vous n'avez pas l'autorisation d'accéder à la Box.",
  "error.403.file": "Vous n'avez pas l'autorisation d'accéder au document.",
  "error.403.file_not_found_or_no_access": "Le fichier n'existe pas ou vous n'avez pas l'autorisation d'accéder au document.",
  "error.403.settings": "Vous n'avez pas l'autorisation d'accéder à ces paramètres.",
  "error.403.wrong_account_email": "L'e-mail du compte avec lequel vous essayez de signer ce document ne correspond pas à celui auquel la demande de signature a été envoyée. Veuillez vous déconnecter et rouvrir le lien que vous avez reçu par e-mail.",
  "error.413.file_too_big": "Fichier trop grand",
  "error.axios.ERR_NETWORK": "La connexion a été interrompue",
  "error.code": "Code",
  "error.codes.ERR_FILE_NOT_FOUND": "Fichier non trouvé",
  "error.codes.KC_ERROR_UPDATE_TOKEN": "Session invalide",
  "error.codes.UPLOAD_PARENT_NODE_ID_CAN_NOT_BE_EMPTY": "L'ID du nœud parent ne peut pas être vide",
  "error.download.multiple.n_max_length": "Un maximum de {n} éléments sélectionnés peuvent être téléchargés en même temps.",
  "error.download.not_possible": "Téléchargement impossible",
  "error.email_do_not_match.description": "Vous êtes en train de créer un compte avec l’e-mail <b>{newEmail}</b>, mais vous êtes toujours connecté avec l'e-mail suivant: <b>{currentEmail}</b> .\n<br />\nVeuillez vous déconnecter pour créer un compte avec un nouvel e-mail.",
  "error.email_do_not_match.title": "E-mail ne correspond pas",
  "error.error_occurred": "Une erreur s'est produite",
  "error.home": "Accueil",
  "error.inbox.folders_are_not_allowed": "Les dossiers ne sont pas pris en charge dans la boîte de réception. 1 dossier ne sera pas déplacé. | Les dossiers ne sont pas pris en charge dans la boîte de réception. {n} dossiers ne seront pas déplacés.",
  "error.invalid_or_missing_params": "Paramètres invalides ou manquants",
  "error.invalid_param_email": "Paramètres d'e-mail invalides",
  "error.invalid_password": "Mot de passe invalide",
  "error.invalid_url_service_param": "Paramètre de service url invalide",
  "error.key_invalid_or_expired": "Key est invalide ou a expiré",
  "error.logged_out": "Vous avez été déconnecté",
  "error.login": "Retour à la page de connexion",
  "error.organization_not_found": "Organisation non trouvée",
  "error.page_not_found": "Page non trouvée",
  "error.page_not_found_or_missing_permissions": "Page introuvable ou vous n'avez pas les autorisations nécessaires pour accéder à cette ressource",
  "error.url_invalid": "L’URL est invalide ou a expiré",
  "error.validation.invalid": "Veuillez vérifier votre saisie",
  "external_services.aba_ninja.description": "Connecter programme de comptabilité",
  "external_services.deepmail.description": "Envoyer un Deep Mail",
  "external_services.hoop.description": "Fonder et muter des entreprises en ligne",
  "external_services.title": "Applications rendues possibles par DeepBox",
  "fields.country_select.label": "Sélectionner le pays",
  "fields.errors.invalid_email": "Le mail n'est pas valide",
  "fields.errors.invalid_password": "Le mot de passe ne correspond pas aux règles de validation",
  "fields.errors.max_length": "La longueur maximale de {maxLength} a été dépassée",
  "fields.errors.min_length": "La longueur minimale de {minLength} n'a pas été atteinte.",
  "fields.errors.required": "Champ obligatoire",
  "fields.multi_language_text.btn_add": "Ajouter une langue",
  "fields.multi_language_text.field_key_label": "Langue",
  "fields.multi_language_text.field_value_label": "Texte",
  "fields.password.label": "Mot de passe",
  "fields.password_with_verification.hint": "Au moins {counter} caractères (lettres, chiffres et symboles)",
  "fields.phone.placeholder": "Saisir le numéro de téléphone",
  "fields.search_for_boxes.placeholder": "Rechercher des Box",
  "fields.uid.label": "DIE",
  "fields.uid.placeholder.country.ch": "Ex: {example}",
  "fields.uid.placeholder.country.row": "Saisir l'IDE",
  "fields.zip_city.city.label": "Lieu",
  "fields.zip_city.zip.label": "NPA",
  "form.de": "Allemand",
  "form.email": "email",
  "form.en": "Anglais",
  "form.extension": "Extension",
  "form.fr": "Français",
  "form.it": "Italien",
  "form.manage_translations": "Gérer les traductions",
  "form.message": "message",
  "form.name": "Nom",
  "form.noDataText": "Pas de données disponibles",
  "form.type": "Type",
  "hints.analysis.failed": "Analyse échouée",
  "hints.analysis.running": "Analyse en cours...",
  "hints.expired": "Expiré",
  "hints.expires": "Expire",
  "hints.n_files": "1 fichier | {n} fichiers",
  "hints.n_folders": "1 dossier | {n} dossiers",
  "inbox_address.btn_generate": "Générer une nouvelle adresse",
  "inbox_address.delete.msg": "Tu es sûre de vouloir supprimer cette adresse ?",
  "inbox_address.delete.title": "Supprimer l'adresse",
  "inbox_address.delete_address": "Supprimer l'adresse",
  "inbox_address.description": "Générez des adresses uniques qui peuvent être utilisées pour recevoir des documents directement dans votre inbox par e-mail ou outil de téléchargement . Toute personne ayant accès à ces adresses peut vous envoyer des fichiers. Faites donc attention avec qui vous les partagez. Les adresses peuvent être désactivées à tout moment. {link}",
  "inbox_address.description_short": "Générez des adresses uniques qui peuvent être utilisées pour recevoir des documents directement dans votre inbox par e-mail ou outil de téléchargement... {link}",
  "inbox_address.edit.label.description": "Description",
  "inbox_address.edit.label.email_link": "Lien e-mail",
  "inbox_address.edit.label.upload_link": "Lien de téléchargement",
  "inbox_address.manage_all_addresses": "Gérer les adresses",
  "inbox_address.title": "Adresse pour cette inbox",
  "inbox_address.toast.error.email_disabled": "Le lien de téléchargement n'a pas pu être désactivé",
  "inbox_address.toast.error.email_enabled": "Le lien de téléchargement n'a pas pu être activé",
  "inbox_address.toast.error.upload_disabled": "Lien e-mail n'a pas pu être désactivé",
  "inbox_address.toast.error.upload_enabled": "Lien e-mail n'a pas pu être activé",
  "inbox_address.toast.success.email_disabled": "Lien e-mail désactivé avec succès",
  "inbox_address.toast.success.email_enabled": "Le lien e-mail a été activé avec succès",
  "inbox_address.toast.success.generated": "L'adresse a été générée avec succès",
  "inbox_address.toast.success.saved": "Adresse enregistrée avec succès",
  "inbox_address.toast.success.upload_disabled": "Le lien de téléchargement a été désactivé avec succès",
  "inbox_address.toast.success.upload_enabled": "Le lien de téléchargement a été activé avec succès",
  "labels.attachments": "Pièces jointes",
  "labels.boxes_shared_with_me": "Partagé avec moi",
  "labels.clear_all": "Supprimer tout",
  "labels.description": "Description",
  "labels.documents_in_inbox": "Document dans l'Inbox | Documents dans l'Inbox",
  "labels.email": "Email",
  "labels.favorite": "Favori",
  "labels.favorites": "Favoris",
  "labels.files": "Fichier | Fichiers",
  "labels.filter": "Filtre",
  "labels.insufficient_permissions": "Permissions insuffisantes",
  "labels.less": "moins",
  "labels.load_more": "Charger plus",
  "labels.menu.actions.favorites.add": "Ajouter aux favoris",
  "labels.menu.actions.favorites.remove": "Supprimer des favoris",
  "labels.more": "plus",
  "labels.n_elements_selected": "1 élément sélectionné | {n} éléments sélectionnés",
  "labels.open": "Ouvrir",
  "labels.open_dashboard": "Ouvrir le Dashboard",
  "labels.others": "autre | autres",
  "labels.recents": "Récents",
  "labels.request_message": "Demande d'assistance",
  "labels.section": "Section",
  "labels.show_all": "Tout afficher",
  "labels.show_less": "Montrer moins",
  "labels.show_more": "Montrer plus",
  "labels.suggestions": "Suggestions",
  "labels.valid_from": "Valable à partir de",
  "labels.valid_until": "Valable jusqu'à",
  "links.read_more": "En savoir plus",
  "loader.files.are_being_indexed": "Les fichiers sont en cours d'indexation...",
  "loader.is_loading": "Chargement...",
  "main_view.all": "Tout afficher",
  "main_view.boxes_shared_with_me": "Box partagées avec moi",
  "main_view.deadlines": "Échéances",
  "main_view.favorites": "Favoris",
  "main_view.inbox": "Inbox",
  "main_view.recents": "Récents",
  "main_view.search_for_boxes": "Rechercher des Box",
  "messages.error.deepsign_file_max_size": "Seuls les fichiers d'une taille maximale de {size} peuvent être signés.",
  "messages.error.deepvalidator_file_max_size": "Seuls les fichiers d'une taille maximale de {size} peuvent être ouverts avec DeepValidator.",
  "messages.error.file_size": "Seuls les fichiers d'une taille maximale de 2 Go peuvent être déposés.",
  "messages.no_box_found": "Aucune Box n'a été trouvée.",
  "messages.no_boxes_found": "Aucune box trouvée",
  "messages.no_boxes_found_title": "Pas de boîtes",
  "messages.success.box_created": "Box créée avec succès",
  "messages.success.copy_of": "Copie de {fileName} créée avec succès | Copie des fichiers {n} réussie",
  "messages.success.delete": "1 fichier déplacé vers la corbeille | {n} fichiers déplacés vers la corbeille",
  "messages.success.delete_permanently": "1 fichier définitivement supprimé | {n} fichiers définitivement supprimés",
  "messages.success.file_converted_to_pdf": "Fichier {fileName} créé avec succès | {n} Fichiers PDF créés avec succès",
  "messages.success.file_upload": "Aucun document n'a été téléchargé vers {destination} | {number} document a été téléchargé vers {destination} | {number} éléments ont été téléchargés vers {destination}.",
  "messages.success.folder_created": "Dossier {name} a été créé avec succès.",
  "messages.success.folder_upload": "Le dossier {destination} a été créé.  | Le dossier {destination} a été créé et {number} document y a été téléchargé. Le dossier {destination} a été créé et {number} documents y ont été téléchargés.",
  "messages.success.move": "Aucun élément n'a été déplacé vers {destination} | {n} élément a été déplacé vers {destination} . | Les éléments {n} ont été déplacés vers {destination}.",
  "messages.success.move_to_box_element": "Aucun élément n'a été déplacé dans le dossier \"{folderName}\" de la box \"{boxName}\" | {n} élément a été déplacé dans le dossier \"{folderName}\" de la box \"{boxName}\" | {n} éléments ont été déplacés dans le dossier \"{folderName}\" de la box \"{boxName}\"",
  "messages.success.move_to_box_file": "Aucun fichier n'a été déplacé dans le dossier \"{folderName}\" de la box \"{boxName}\" | {n} fichier a été déplacé dans le dossier \"{folderName}\" de la box \"{boxName}\" | {n} fichiers ont été déplacés dans le dossier \"{folderName}\" de la box \"{boxName}\"",
  "messages.success.restore": "1 fichier restauré avec succès | {n} fichiers restaurés avec succès",
  "msgbox.btn_agree": "Confirmer",
  "msgbox.btn_cancel": "Annuler",
  "msgbox.checkbox.validation.required": "Champ obligatoire ",
  "navigation.collapse_sidebar": "Masquer la barre latérale",
  "navigation.dashboard": "Dashboard",
  "navigation.deepbox_settings": "Paramètres de Box",
  "navigation.deepo_settings": "Paramètres de DeepO",
  "navigation.of": "{currentFile} sur {filesNumber}",
  "navigation.recent": "Récents",
  "navigation.recent_boxes": "Récents boxes",
  "navigation.tabs.all": "Toutes les box",
  "navigation.tabs.favorites": "Favoris",
  "navigation.tabs.files": "Documents",
  "navigation.tabs.inbox": "Inbox",
  "navigation.tabs.recent": "Récents",
  "navigation.tabs.trash": "Corbeille",
  "no_box.box_name": "Box de mon entreprise",
  "no_box.button_text": "Créez votre propre DeepBox",
  "no_box.features.automate_document_processing": "Traitement automatique des documents",
  "no_box.features.connect": "Se connecter avec des tiers",
  "no_box.features.share_documents": "Partager des documents ",
  "no_box.features.store_your_documents": "Stockez vos propres documents",
  "no_box.title": "Exemple de société SA",
  "node.cloudoffice.msg_box.terms.member.content": "Le service Microsoft 365 web n'est pas encore activé par votre organisation. {lien}",
  "node.cloudoffice.msg_box.terms.member.title": "Non déverrouillé",
  "node.cloudoffice.msg_box.terms.owner.checkbox.label": "Je suis d'accord avec les conditions.",
  "node.cloudoffice.msg_box.terms.owner.content": "Pour le traitement des fichiers, vous utilisez un service Microsoft. Veuillez confirmer que vous acceptez les conditions d'utilisation de Microsoft et leur politique de confidentialité. Les conditions d'utilisation de la DeepCloud REST API s'appliquent également.",
  "node.cloudoffice.msg_box.terms.owner.title": "Microsoft 365 web",
  "node.download.errors.av_scan_file_too_big.btn.agree": "Télécharger quand même",
  "node.download.errors.av_scan_file_too_big.checkbox.label": "Je comprends les risques et souhaite quand même télécharger le fichier | Je comprends les risques et souhaite quand même télécharger les fichiers",
  "node.download.errors.av_scan_file_too_big.message": "Le fichier ne peut pas être vérifié pour les virus car il est trop grand. <br />\nLe fichier peut être dangereux, alors ne le télécharge que si vous comprenez les risques. | Au moins un fichier n'a pas pu être contrôlé pour les virus car il est trop gros. <br />\nLe fichier peut être dangereux, ne le téléchargez donc que si vous en comprenez les risques.",
  "node.download.errors.av_scan_file_too_big.title": "Recherche de virus échouée",
  "node.download.errors.av_scan_virus_found.btn.agree": "Télécharger quand même",
  "node.download.errors.av_scan_virus_found.checkbox.label": "Je comprends les risques et souhaite quand même télécharger le fichier | Je comprends les risques et souhaite quand même télécharger les fichiers",
  "node.download.errors.av_scan_virus_found.message": "Notre scanner de virus a trouvé un virus dans ce fichier.  <br />\nNous vous recommandons de ne pas télécharger les fichiers car ils peuvent être dangereux. | Notre logiciel antivirus a trouvé un virus dans au moins un fichier. <br />\nNous vous recommandons de ne pas télécharger les fichiers car ils peuvent être dangereux.",
  "node.download.errors.av_scan_virus_found.title": "ATTENTION : Virus trouvé",
  "node.download.errors.av_scan_virus_found_and_file_too_big.btn.agree": "Télécharger quand même",
  "node.download.errors.av_scan_virus_found_and_file_too_big.checkbox.label": "Je comprends les risques et j'aimerais quand même télécharger le fichier. | Je comprends les risques et je souhaite quand même télécharger les fichiers.",
  "node.download.errors.av_scan_virus_found_and_file_too_big.message": "Il nostro scanner antivirus ha rilevato un virus in questo file o questo file non ha potuto essere scansionato a causa delle sue dimensioni.<br />Consigliamo di non scaricare il file perché potrebbe essere dannoso. | Notre antivirus a détecté un virus dans ce fichier ou ce fichier n'a pas pu être analysé en raison de sa taille.<br />\nNous vous recommandons de ne pas télécharger le fichier car il pourrait être dangereux. | Notre antivirus a trouvé un virus dans au moins un fichier ou au moins un fichier n'a pas pu être contrôlé en raison de sa taille.<br />\nNous recommandons de ne pas télécharger les fichiers car ils pourraient être dangereux.",
  "node.download.errors.av_scan_virus_found_and_file_too_big.title": "Attention !",
  "node.download.success": "Début du téléchargement",
  "node.download.zip_snackbar.generating_zip_file": "Génération de fichier ZIP | Génération de {n} fichiers ZIP",
  "node.download.zip_snackbar.zip_download": "Téléchargement ZIP",
  "node.preview.errors.av_scan_file_too_big.btn.agree": "Montrer quand même",
  "node.preview.errors.av_scan_file_too_big.checkbox.label": "Je comprends les risques et souhaite quand même consulter le dossier | Je comprends les risques et souhaite quand même consulter les dossiers",
  "node.preview.errors.av_scan_file_too_big.message": "Il n'a pas été possible de rechercher des virus dans ce fichier car il est trop volumineux.<br />\nLe fichier peut être dangereux, ne le consultez que si vous en connaissez les risques.",
  "node.preview.errors.av_scan_file_too_big.title": "Recherche de virus échouée",
  "node.preview.errors.av_scan_virus_found.btn.agree": "Montrer quand même",
  "node.preview.errors.av_scan_virus_found.checkbox.label": "Je comprends les risques et je veux quand même consulter le fichier.",
  "node.preview.errors.av_scan_virus_found.message": "Notre scanner de virus a trouvé un virus dans ce fichier.<br />\nLe fichier peut être dangereux, ne le consultez que si vous en connaissez les risques.",
  "node.preview.errors.av_scan_virus_found.title": "ATTENTION : Virus trouvé",
  "node.share_link.errors.av_scan_file_too_big.btn.agree": "Partager quand même",
  "node.share_link.errors.av_scan_file_too_big.checkbox.label": "Je comprends les risques et souhaite quand même partager le fichier | Je comprends les risques et souhaite quand même partager les fichiers",
  "node.share_link.errors.av_scan_file_too_big.message": "Le fichier ne peut pas être contrôlé pour les virus car il est trop grand (<b>{fileSize}</b>). <br />\nLe fichier peut être dangereux, ne le partagez donc que si vous en comprenez les risques.",
  "node.share_link.errors.av_scan_file_too_big.title": "Recherche de virus échouée",
  "node.virus.table.headers.file": "Fichier",
  "node.virus.table.headers.virus_signature": "Signature du virus",
  "node_data_table.actions.add_deadline": "Ajouter une échéance",
  "node_data_table.actions.analyze": "Analyser",
  "node_data_table.actions.assign_tags": "Ajouter des tags",
  "node_data_table.actions.continue_deepsign": "Continuer sur DeepSign",
  "node_data_table.actions.convert_to_pdf": "Convertir en PDF",
  "node_data_table.actions.copy_of": "Faire une copie",
  "node_data_table.actions.deepa_chat": "Discuter avec DeepA",
  "node_data_table.actions.deepmail": "Envoyer avec DeepMail",
  "node_data_table.actions.delete_permanently": "Supprimer définitivement",
  "node_data_table.actions.details_deepsign": "Voir les détails sur DeepSign",
  "node_data_table.actions.download": "Télécharger",
  "node_data_table.actions.edit": "Éditer",
  "node_data_table.actions.edit_deadline": "Éditer l'échéance",
  "node_data_table.actions.edit_tags": "Modifier tags",
  "node_data_table.actions.flow_start": "Démarrer le flow",
  "node_data_table.actions.group.actions": "Actions",
  "node_data_table.actions.group.organize": "Organiser",
  "node_data_table.actions.hidden": "Caché",
  "node_data_table.actions.move_to": "Déplacer vers",
  "node_data_table.actions.move_to_trash": "Déplacer vers la poubelle",
  "node_data_table.actions.pay": "Payer",
  "node_data_table.actions.pdf_compare": "Comparer des PDF",
  "node_data_table.actions.rename": "Renommer",
  "node_data_table.actions.restore": "Restaurer",
  "node_data_table.actions.share_link": "Partager lien",
  "node_data_table.actions.show_details": "Afficher détails",
  "node_data_table.actions.sign": "Signer avec DeepSign",
  "node_data_table.actions.summarization": "Résumer avec DeepA",
  "node_data_table.headers.date": "Date",
  "node_data_table.headers.deleted.time": "Supprimé",
  "node_data_table.headers.deleted.user": "Supprimé par",
  "node_data_table.headers.document_type": "Type",
  "node_data_table.headers.location": "Emplacement",
  "node_data_table.headers.modified": "Modifié",
  "node_data_table.headers.name": "Nom",
  "node_data_table.headers.owner": "Propriétaire",
  "node_data_table.headers.received": "Réception",
  "node_data_table.headers.retained_until": "Conservé jusqu'au",
  "node_data_table.headers.signature": "Signature",
  "node_data_table.headers.size": "Taille",
  "node_data_table.headers.timestamp": "Horodatage",
  "node_data_table.me": "Moi",
  "node_data_table.mobile.sort_keys.largest": "Plus grand",
  "node_data_table.mobile.sort_keys.name_asc": "Nom croissant",
  "node_data_table.mobile.sort_keys.name_desc": "Nom descendant",
  "node_data_table.mobile.sort_keys.newest": "Plus récent",
  "node_data_table.mobile.sort_keys.oldest": "Plus ancien",
  "node_data_table.mobile.sort_keys.smallest": "Plus petit",
  "node_data_table.sign": "Signer",
  "node_data_table.tags": "Tags",
  "node_data_table.tags_multiple": "Plusieurs tags",
  "node_data_table.tooltip.comment": "Commenter",
  "node_data_table.tooltip.comments_show": "Afficher les commentaires",
  "node_data_table.tooltip.sign_status_pending": "Signature(s) en attente",
  "node_data_table.tooltip.sign_status_signed": "Entièrement signé",
  "node_data_table.views.hidden": "Afficher les éléments masqués",
  "node_data_table.views.list": "Grande liste",
  "node_data_table.views.list_dense": "Liste",
  "nodes.convert_to_pdf_and_sign_msg_box.checkbox.label": "Ne plus afficher",
  "nodes.convert_to_pdf_and_sign_msg_box.errors.file_to_big_mb": "Le fichier est trop volumineux. La taille maximale du fichier est de {maxFileSize} MB",
  "nodes.convert_to_pdf_and_sign_msg_box.msg": "Une copie PDF de votre fichier est créée pour être signée avec DeepSign et enregistrée au même endroit dans votre DeepBox.",
  "nodes.convert_to_pdf_and_sign_msg_box.msg_converting_file_to_pdf": "Le fichier sera converti en PDF",
  "nodes.convert_to_pdf_and_sign_msg_box.title": "Le PDF à signer est créé",
  "nodes.files_description_types.audio": "audio",
  "nodes.files_description_types.document": "document",
  "nodes.files_description_types.file": "fichier",
  "nodes.files_description_types.image": "image",
  "nodes.files_description_types.video": "vidéo",
  "nodes.upload_card.labels.count_error": "1 échec | {n} échec",
  "nodes.upload_card.labels.count_n_of_total": "{n} de {total} éléments",
  "nodes.upload_card.title": "Téléchargements",
  "onlyoffice.editor.open_file_location": "Ouvrir l'emplacement du fichier",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.actions.support": "DeepCloud",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.text": "Il existe plusieurs factures impayées qui doivent être réglées. C'est pourquoi le compte a été bloqué. Veuillez contacter votre administrateur pour débloquer le compte.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.actions.open_invoices": "Aux factures",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.text": "Il existe plusieurs factures impayées qui doivent être réglées. C'est pourquoi le compte a été bloqué. Veuillez régler les factures impayées pour débloquer le compte.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.title": "Paiements en attente",
  "overlays.overused_subscription.has_overused_box_users.admin_or_member.text": "Votre DeepBox a trop d'utilisateurs ou trop de box utilisés par rapport à ce qui est actuellement disponible dans votre abonnement. Veuillez informer un propriétaire de cette DeepBox afin qu'il puisse adapter l'abonnement.",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_organization": "Gérer votre organisation",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_subscription": "Gérer votre abonnement",
  "overlays.overused_subscription.has_overused_box_users.owner.text": "Votre DeepBox a trop d'utilisateurs ou trop de box utilisés par rapport à ce qui est actuellement disponible dans votre abonnement. Veuillez activer l'abonnement correspondant pour cette DeepBox ou supprimer les utilisateurs ou les box.",
  "overlays.overused_subscription.has_overused_box_users.title": "Vous devez activer un abonnement afin de continuer à utiliser cette DeepBox.",
  "overlays.overused_subscription.learn_more": "En savoir plus sur les abonnements DeepBox: ",
  "overlays.overused_subscription.title": "Abonnement",
  "page_titles.search_results": "Résultats de la recherche",
  "pages.dashboard.deadlines": "Échéances",
  "pages.dashboard.empty.text": "Vos Box seront affichées ici",
  "pages.dashboard.empty.text_can_not_onboard": "Vous n'avez pas les droits nécessaires pour créer une boîte. <br />\nContactez un propriétaire ou un administrateur de votre organisation.",
  "pages.dashboard.empty.text_create_box": "Créez gratuitement votre première box pour utiliser la plateforme suisse tout-en-un d'échange sécurisé de documents.",
  "pages.dashboard.empty.title": "Aucune Box disponible",
  "pages.dashboard.inbox": "Inbox",
  "pages.dashboard.labels.all_sections": "Toutes les sections",
  "pages.dashboard.labels.display_all_n": "Afficher tous ({n})",
  "pages.dashboard.labels.tabs": "Tabs",
  "pages.dashboard.onboarding.banner.actions.continue": "Continuez l'onboarding",
  "pages.dashboard.onboarding.banner.text_in_progress": "Pour pouvoir utiliser votre propre DeepBox, vous devez terminer le processus d'intégration.",
  "pages.dashboard.onboarding.banner.text_not_started": "Pour pouvoir utiliser DeepBox vous-même, vous devez compléter votre compte.",
  "pages.dashboard.private_box_title": "Pour vous",
  "pages.links.alert_info": "Ce lien expirera dans 1 jour | Ce lien expirera dans {n} jours",
  "pages.links.alert_msg_date_expired": "Le lien est expiré",
  "pages.links.btn_download": "Télécharger",
  "pages.links.btn_view": "Voir",
  "pages.links.file_preview_not_available": "Le fichier ne peut pas être prévisualisé.",
  "pages.store.services.aba_ninja.category": "Comptabilité",
  "pages.store.services.aba_ninja.content": "<div>\nDeepNinja est le programme de comptabilité qui vous permet de gérer facilement les finances de votre entreprise. L'outil efficace pour les offres, les factures, les paiements, la saisie des temps et bien plus encore, qui vous assiste dans les tâches administratives. Grâce à la nouvelle connexion DeepBox/DeepNinja, les documents peuvent être facilement échangés et ensuite traités automatiquement directement avec le programme de comptabilité.\n</div>\n<br />\n<div>\nAinsi, vous pouvez directement ouvrir un compte DeepNinja et le connecter à votre DeepBox.\n</div>\n<div class=\"mt-4\">Vos avantages:</div>\n<ul>\n  <li>Créez des offres et des factures et stockez-les dans DeepBox</li>\n  <li>Traitement automatique des factures des fournisseurs avec DeepBox</li>\n  <li>Saisie simple des heures et des services</li>\n  <li>Connexion directe à la comptabilité financière Abacus ERP</li>\n</ul>",
  "pages.store.services.aba_ninja.languages": "Allemand, français, italien, anglais",
  "pages.store.services.aba_ninja.price": "CHF 21.- par mois",
  "pages.store.services.aba_ninja.subtitle": "Programme de comptabilité",
  "pages.store.services.aba_ninja.title": "DeepNinja",
  "pages.store.services.hoop.category": "Création d'entreprise",
  "pages.store.services.hoop.content": "<div>\nHoop est l'application innovante pour les fiduciaires proposée par DeepBox, grâce à laquelle les sociétés peuvent être créées simplement et de manière 100% numérique. De la saisie des données de création d’entreprise à la mise en place du compte de consignation de capital de l’entreprise et à l'inscription au registre du commerce, le processus est entièrement numérisé et couvre toutes les étapes de la création de l’entreprise.\n</div>\n<div class=\"mt-4\">Vos avantages:</div>\n<ul>\n  <li>Un processus simple et 100% numérique</li>\n  <li>Hoop comme interlocuteur unique, pour tous les aspects</li>\n  <li>Ouverture en ligne du compte de consignation de capital</li>\n  <li>Certification notariale avec signature numérique intégrée</li>\n  <li>Tous les documents sont stockés de manière centralisée sur DeepBox</li>\n</ul>\n<div class=\"mt-4\">Formes juridiques possibles:</div>\n<ul>\n  <li>Entreprise individuelle</li>\n  <li>Société à responsabilité limitée (Sàrl)</li>\n  <li>Société anonyme (SA)</li>\n</ul>",
  "pages.store.services.hoop.languages": "Allemand, français, italien, anglais",
  "pages.store.services.hoop.links.contact": "Contact",
  "pages.store.services.hoop.links.title": "Hoop Corporate Services SA",
  "pages.store.services.hoop.links.website": "Site Internet",
  "pages.store.services.hoop.price": "CHF 490.- par création d’entreprise ",
  "pages.store.services.hoop.subtitle": "Processus de crèation d'entreprise numèrique",
  "pages.store.services.hoop.title": "Hoop – Création d'entreprise",
  "pages.upload.add_more_files": "Ajouter d'autres fichiers",
  "pages.upload.dialog_unsupported_files.text": "Il y a 1 fichier non supporté.\nCe fichier ne sera pas téléchargé. \n| Il a {n} fichiers non pris en charge.\nCes fichiers ne seront pas téléchargés.",
  "pages.upload.dialog_unsupported_files.title": "Fichiers non pris en charge",
  "pages.upload.errors.invalid_url": "La page de téléchargement n'est pas valide. Veuillez contacter un administrateur de cette DeepBox.",
  "pages.upload.errors.not_found": "Les fichiers n'ont pas pu être téléchargés. Veuillez recharger la page.",
  "pages.upload.errors.upload_failed": "Certains fichiers n'ont pas pu être téléchargés. Veuillez réessayer.",
  "pages.upload.text_intro": "L'upload direct vous permet de soumettre des fichiers directement à la Box {box} de {organization}.",
  "pages.upload.text_link_validity": "Le lien d'upload se déroule en {n}.",
  "pages.upload.title": "Télécharger des fichiers",
  "pages.upload.upload_error": "1 fichier n'a pas pu être téléchargé | {n} fichiers n'ont pas pu être téléchargés",
  "pages.upload.upload_success": "1 fichier a été téléchargé avec succès | {n} fichiers ont été téléchargés avec succès",
  "placeholders.enter_support_request": "Entrez la description de votre demande ici...",
  "placeholders.filter_by_owner": "Filtrer par propriétaire",
  "placeholders.filter_by_tags": "Filtrer par tags",
  "placeholders.search": "Rechercher...",
  "placeholders.search_box": "Rechercher une box...",
  "placeholders.search_in_box": "Rechercher dans {box} ",
  "placeholders.search_tags": "Recherche de tags...",
  "placeholders.select": "Sélectionner",
  "preview.analyse.btn_action": "Analyser",
  "preview.analyse.loader_is_being_analysed": "Le document est en cours d'analyse",
  "preview.analyse.text": "Ce document n'a pas encore été analysé.",
  "preview.analyse.toaster.success": "Le document a été analysé",
  "preview.dialog.password.text": "Veuillez saisir le mot de passe du fichier",
  "preview.dialog.password.text_retry": "Veuillez saisir à nouveau le mot de passe du fichier",
  "preview.dialog.password.title": "Fichiers cryptés",
  "preview.edit.toaster.saved": "Modifications enregistrées",
  "preview.error.text": "Le fichier est peut-être endommagé. Vous pouvez tout de même le télécharger.",
  "preview.error.title": "Ce fichier n'a pas pu être ouvert",
  "preview.no_preview.title": "Ce fichier ne peut pas être prévisualisé",
  "preview.node_actions.open": "Ouvrir",
  "preview.node_actions.text_download": "Télécharger",
  "preview.node_actions.text_pages": "{currentPage} sur {totalPages} pages",
  "preview.node_actions.text_print": "Imprimer",
  "preview.not_available": "Aucun aperçu n'est disponible",
  "preview.rendering": "Rendu en cours...",
  "preview.toaster.error.document_loading_failed": "Une erreur s'est produite lors du chargement du document. Veuillez réessayer plus tard.",
  "search.advanced": "Avancé...",
  "search.current": "Localisation actuelle - {location}",
  "search.enter_some_text": "Entrez du texte dans le champ de recherche...",
  "search.everywhere": "Partout -  {location}",
  "search.in": "Dans",
  "search.instructions.lede": "Il suffit de saisir un ou plusieurs termes pour une recherche simple, les fichiers les plus pertinents apparaissent en premier. Pour des requêtes plus ciblées, combinez les opérateurs ci-dessous.",
  "search.instructions.note.tip1": "La casse des termes de recherche n'a pas d'importance, <b>rapport</b> trouve aussi <b>Rapport</b>.",
  "search.instructions.note.tip2": "Un plus grand nombre de termes entraîne davantage de résultats potentiels. Les résultats les plus pertinents apparaissent toujours en premier.",
  "search.instructions.section1.description": "Plusieurs mots élargissent la recherche. Les fichiers contenant tous les termes sont automatiquement mieux classés.",
  "search.instructions.section1.example1.description": "Tous les fichiers contenant <b>rapport</b>.",
  "search.instructions.section1.example1.query": "rapport",
  "search.instructions.section1.example2.description": "<b>rapport</b> ou <b>budget</b>, les résultats contenant les deux termes apparaissent en tête.",
  "search.instructions.section1.example2.query": "rapport budget",
  "search.instructions.section1.example3.description": "Uniquement la séquence exacte <b>rapport annuel 2024</b>.",
  "search.instructions.section1.example3.query": "\"rapport annuel 2024\"",
  "search.instructions.section1.example4.description": "<b>contrat</b> ou la phrase <b>rapport annuel 2024</b>.",
  "search.instructions.section1.example4.query": "contrat \"rapport annuel 2024\"",
  "search.instructions.section1.title": "Recherche par termes",
  "search.instructions.section2.description": "Un + placé devant un terme le rend obligatoire, un − l'exclut.",
  "search.instructions.section2.example1.description": "Doit contenir <b>rapport</b>, <b>budget</b> est optionnel.",
  "search.instructions.section2.example1.query": "+rapport budget",
  "search.instructions.section2.example2.description": "<b>rapport</b>, mais sans <b>brouillon</b>.",
  "search.instructions.section2.example2.query": "rapport -brouillon",
  "search.instructions.section2.example3.description": "Doit contenir les deux termes.",
  "search.instructions.section2.example3.query": "+rapport +budget",
  "search.instructions.section2.example4.description": "Phrase <b>rapport annuel 2024</b>, sans <b>brouillon</b>.",
  "search.instructions.section2.example4.query": "\"rapport annuel 2024\" -brouillon",
  "search.instructions.section2.title": "Critères obligatoires et d'exclusion",
  "search.instructions.section3.description": "Les opérateurs doivent être écrits en majuscules. Les parenthèses regroupent les conditions qui vont ensemble.",
  "search.instructions.section3.example1.description": "Doit contenir les deux termes.",
  "search.instructions.section3.example1.query": "rapport AND budget",
  "search.instructions.section3.example2.description": "Au moins l'un des deux termes.",
  "search.instructions.section3.example2.query": "facture OR reçu",
  "search.instructions.section3.example3.description": "<b>rapport</b>, mais sans <b>brouillon</b>.",
  "search.instructions.section3.example3.query": "rapport NOT brouillon",
  "search.instructions.section3.example4.description": "(<b>facture</b> ou <b>reçu</b>) et <b>2024</b>.",
  "search.instructions.section3.example4.query": "(facture OR reçu) AND 2024",
  "search.instructions.section3.example5.description": "<b>rapport</b> et l'une des deux phrases.",
  "search.instructions.section3.example5.query": "rapport AND (\"Q3 2024\" OR \"Q4 2024\")",
  "search.instructions.section3.title": "Combiner avec AND, OR, NOT",
  "search.instructions.title": "Aide à la recherche",
  "search.location": "Lieu",
  "search.modified": "Modifié",
  "search.modified_14d": "Il y a 14 jours",
  "search.modified_1h": "Il y a 1 heure",
  "search.modified_24h": "Il y a 24 heures",
  "search.modified_30d": "Il y a 30 jours",
  "search.modified_7d": "Il y a 7 jours",
  "search.modified_pick_date": "Choisir une date…",
  "search.modified_range_last_12m": "12 derniers mois",
  "search.modified_range_last_30d": "30 derniers jours",
  "search.modified_range_last_3m": "3 derniers mois",
  "search.modified_range_last_7d": "7 derniers jours",
  "search.modified_range_month_to_date": "Ce mois",
  "search.modified_range_today": "Aujourd'hui",
  "search.modified_range_year_to_date": "Cette année",
  "search.more_locations": "Autres sites",
  "search.no_results": "Aucun résultat",
  "search.no_results_title": "Aucun élément trouvé",
  "search.no_results_title_location": "Aucun élément trouvé dans {location}",
  "search.owner": "Propriétaire",
  "search.results_found": "Aucun résultat pour \"{searchTerm}\" | {n} résultat pour \"{searchTerm}\" | {n} résultats pour \"{searchTerm}\"",
  "search.search_everywhere_link": "Rechercher partout",
  "search.select_location": "Sélectionnez l'emplacement...",
  "search.tags": "Tags",
  "search.title": "Résultats de la recherche",
  "seo.description": "Édition efficace et collaborative de vos documents. Stockage et partage sécurisés de vos documents sur votre ordinateur ou votre appareil mobile.",
  "services.download.snackbar.generate_in_progress": "Génération d'un fichier zip...",
  "services.download.snackbar.generate_success": "Zip créé. Téléchargement...",
  "store.app_bar.btn_cancel": "Annuler",
  "store.app_bar.title": "Applications abilitées par DeepBox",
  "store.services.container.bottom.category": "Catégorie",
  "store.services.container.bottom.languages": "Langues",
  "store.services.container.bottom.price": "Prix",
  "test.weblate": "Test weblate source code",
  "toast.box.favorites.success_added": "La Box \"{boxName}\" a été ajoutée avec succès à partir des favoris.",
  "toast.box.favorites.success_removed": "La Box \"{boxName}\" a été supprimée avec succès de vos favoris.",
  "toast.error.copy_value": "La valeur n'a pas pu être copiée ",
  "toast.success.copy_value": "La valeur n a été copié avec succès",
  "tooltip.icons.copy": "Copier",
  "tooltip.icons.deepa_chat": "DeepA Chat",
  "tooltip.icons.deepadmin_profile": "Gestion de DeepBox",
  "tooltip.icons.delete": "Supprimer",
  "tooltip.icons.delete_all": "Supprimer tous",
  "tooltip.icons.details_panel": "Liste détaillée",
  "tooltip.icons.download": "Télécharger",
  "tooltip.icons.edit": "Editer",
  "tooltip.icons.help_and_support": "Aide/Support",
  "tooltip.icons.move": "Déplacer",
  "tooltip.icons.qr_code": "Scanner le code QR",
  "tooltip.icons.search_filter": "Filtre de recherche",
  "tooltip.icons.search_instructions": "Aide à la recherche",
  "tooltip.icons.view_raw": "Voir brut",
  "tooltip.icons.view_rendered": "Voir le rendu",
  "tooltip.open": "Ouvrir",
  "upload.dropzone.add_files": "Ajouter des fichiers",
  "upload.dropzone.add_files_more": "Ajouter d'autres fichiers",
  "upload.dropzone.default_hint": "Glisser-déposer des fichiers ou télécharger des fichiers",
  "upload.dropzone.dict_cancel_upload": "Annuler le téléchargement",
  "upload.dropzone.dict_fallback_message": "Votre navigateur ne supporte pas les téléchargements de fichiers par glisser-déposer",
  "upload.dropzone.dict_fallback_text": "Utilisez le formulaire pour télécharger vos fichiers",
  "upload.dropzone.dict_file_too_big": "Le fichier est trop volumineux. La taille maximale du fichier est de {'{'}{'{'}maxFilesize{'}'}{'}'} MB",
  "upload.dropzone.dict_invalid_file_type": "Un fichier de ce type ne peut pas être téléchargé",
  "upload.dropzone.dict_max_files_exceeded": "Vous ne pouvez plus télécharger d'autres fichiers",
  "upload.dropzone.dict_remove_file": "Supprimer un fichier",
  "upload.dropzone.dict_response_error": "Le serveur a refusé votre demande avec le statut {'{'}{'{'}statusCode{'}'}{'}'}.",
  "upload.dropzone.dict_upload_canceled": "Le téléchargement a été annulé",
  "upload.dropzone.files_count_added": "1 fichier ajouté |{n}  fichiers ajoutés",
  "upload.dropzone.files_count_unsupported": "{n} non pris en charge",
  "upload.error.axios.ERR_CANCELED": "Le téléchargement a été interrompu",
  "upload.folders": "Dossier | Dossiers",
  "upload.hints.drop_here_to_upload_to": "Déposer des fichiers pour les télécharger :",
  "upload.items": "Fichier | Fichiers",
  "upload.no-permissions": "Vous n'avez pas le droit d'importer des fichiers.",
  "upload.no_items": "Aucune mise en ligne",
  "upload.status.added": "Ajouté",
  "upload.status.canceled": "Annulé",
  "upload.status.completed": "Complété",
  "upload.status.error": "Échec",
  "upload.status.processing": "Traitement",
  "upload.status.warning": "Avertissement",
  "upload.uploaded_folders": "{folderName} téléchargé. | {folderName} {n} de {total} téléchargés.",
  "upload.uploaded_items": "1 élément a été chargé. | {n} de {total} éléments ont été chargés",
  "upload.uploaded_items_with_folders": "1 éléments a été chargé. | {n} de {total} éléments ({numItems} {items}, {numFolders} {folders}) seront chargés.",
  "upload.uploading_folders": "{folderName} en cours de téléchargement. | {folderName} {uploadingCount} de {n} en cours de téléchargement.",
  "upload.uploading_items": "1 élément sera chargé. | {n} de {total} éléments seront chargé.",
  "upload.uploading_items_with_folders": "1 élément sera chargé. | {n} de {total} éléments ({numItems} {items}, {numFolders} {folders}) seront chargés.",
  "upload_qr_code.duration.10_minutes": "10 minutes",
  "upload_qr_code.duration.1_day": "1 jour",
  "upload_qr_code.duration.1_hour": "1 heure",
  "upload_qr_code.duration.30_minutes": "30 minutes",
  "upload_qr_code.duration.5_minutes": "5 minutes",
  "upload_qr_code.duration.custom": "Personnalisé",
  "upload_qr_code.title": "Scanner pour télécharger vers {location}",
  "upload_qr_code.valid_for": "Valable pour",
  "watches.notifications": "Notification",
  "watches.stop.disable.text": "Voulez-vous désactiver les notifications pour {location} ?\nVous ne recevrez plus d'e-mails lorsque de nouveaux documents seront ajoutés.",
  "watches.stop.disable.title": "Désactiver la notification ?",
  "watches.stop.disabled.text": "Les notifications pour {location} ont été désactivées.",
  "watches.stop.disabled.title": "Notification désactivée",
  "watches.toast.error.error_on_remove_watch": "Erreur lors de la suppression de l'observation",
  "watches.toast.error.error_on_start_watch": "Erreur lors du lancement de l'observation",
  "watches.tooltip": "Notification de nouveaux documents dans ce dossier"
}
